let state = {
  auth_token: null,
  user: null
};

export default state;
